import React from "react";
import { Link } from "react-router-dom";
import {
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
} from "mdb-react-ui-kit";
import Footer from "./Footer";

function CommitteeCard({
  committeeCode,
  committeeTitle,
  imageUrl,
  footerLeft,
  footerRight,
  footerLeftClass,
  footerRightClass,
  link,
}) {
  return (
    <Link className="w-100" to={link} target="_blank">
      <MDBCard className="h-100 text-center rounded-0">
        <div className="image-container">
          <MDBCardImage
            className="rounded-0 img-fluid"
            src={imageUrl}
            position="top"
            alt={committeeCode}
          />
        </div>
        <MDBCardBody>
          <MDBCardTitle>{committeeCode}</MDBCardTitle>
          <MDBCardText>{committeeTitle}</MDBCardText>
        </MDBCardBody>
        <Footer
          leftText={footerLeft}
          rightText={footerRight}
          footerLeftClass={footerLeftClass}
          footerRightClass={footerRightClass}
        />
      </MDBCard>
    </Link>
  );
}

export default CommitteeCard;
